import { render, staticRenderFns } from "./WordmarksForm.vue?vue&type=template&id=2bad0002&scoped=true"
import script from "./WordmarksForm.vue?vue&type=script&lang=js"
export * from "./WordmarksForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad0002",
  null
  
)

export default component.exports